module.exports = __webpack_public_path__ + "img/fund-5.1576c3f8.jpg";